import { store } from 'src/store/store';
import { getUserId } from 'shared/store/selectors/user.selector';
import { createProfilePhotoReporter } from 'shared/helpers/src/profile-photo-analytics';
import analyticsService from './analytics.service';

// Drop targetUserId on self-edits; admin edits of other users keep it.
export const profilePhotoReporter = createProfilePhotoReporter((event, props) => {
  if (props?.targetUserId && props.targetUserId === getUserId(store.getState())) {
    const { targetUserId: _drop, ...rest } = props;
    analyticsService.track(event, rest);
  } else {
    analyticsService.track(event, props);
  }
});
